
























































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import CKEditor from "ckeditor4-vue";

import { Dialog, Popup } from "vant";

/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
Vue.use(CKEditor);

@Component({
  components: {
    CKEditor,
  },
})
export default class NewSection extends Vue {
  @Prop() show!: any;
  @Prop() Sections!: any;
  errors: any = [];
  new_section: any = {
    title: null,
    description: null,
    imageUrl: null,
    offlineImageUrl: null,
  };

  @Emit("UpdateChapter")
  UpdateChapter() {
    return this.new_section;
  }

  checkRequired() {
    if (this.new_section.title && this.new_section.description) {
      return true;
    }
    this.errors = [];
    if (!this.new_section.title) {
      this.errors.push("title required.");
    }
    if (!this.new_section.description) {
      this.errors.push("description required.");
    }
  }

  SaveSection() {
    this.checkRequired();
    if (this.checkRequired()) {
      //
      this.Sections.push({
        title: this.new_section.title,
        description: this.new_section.description,
        imageUrl: this.new_section.imageUrl,
      });
      this.new_section.title = this.new_section.description = this.new_section.imageUrl = "";
      window.scrollTo(0, document.body.scrollHeight);
      this.UpdateChapter();
    }

    //
  }
  showPopup() {
    this.show = true;
  }
}
